const Wrapper = ({ children }) => children

export default Wrapper